/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The data value type :
 *   * TEXT : means that the value to acquire is textual
 *   * BOOLEAN : means that the value to acquire is a boolean (0 for false, 1 for true)
 *   * INTEGER : means that the value to acquire is an integer
 *   * DECIMAL : means taht the value to acquire is decimal
 */
export enum DataValueType {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL'
}
